import type { Recipe } from '@awwyeah/shared';

/** Recipe search covers title, ingredients, tags and notes (Screen E · empty search state:
 * "Searched names, ingredients, and tags"). */
export function matchesSearch(recipe: Recipe, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  if (recipe.title.toLowerCase().includes(q)) return true;
  if (recipe.tags.some((t) => t.toLowerCase().includes(q))) return true;
  if (recipe.ingredients.some((i) => i.text.toLowerCase().includes(q))) return true;
  if (recipe.notes?.toLowerCase().includes(q)) return true;
  return false;
}

/** Search + tag filter + "added by" filter, in one place so the page component and tests
 * agree. `creatorId` is an AND with the rest (Faye can search *and* narrow to her own
 * recipes at once) — `null` means no creator filter, matching the tag param's convention. */
export function filterRecipes(
  recipes: Recipe[],
  query: string,
  tag: string | null,
  creatorId: string | null = null,
): Recipe[] {
  return recipes.filter(
    (r) =>
      matchesSearch(r, query) &&
      (!tag || r.tags.includes(tag)) &&
      (!creatorId || r.createdBy === creatorId),
  );
}
